import { FC } from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { FiLock, FiUnlock } from 'react-icons/fi';

interface Props {
  isLocked: boolean;
  onToggleLock: () => void;
}

export const TemplateShiftLock: FC<Props> = ({ isLocked, onToggleLock }) => {
  return (
    <RadixTooltip.Provider delayDuration={500}>
      <RadixTooltip.Root>
        <RadixTooltip.Trigger>
          <button onClick={onToggleLock} className="flex items-center gap-2">
            {isLocked ? <FiLock className="h-6 w-6 text-red-500" /> : <FiUnlock className="h-6 w-6 text-gray-500" />}
          </button>
        </RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content
            side={'right'}
            sideOffset={5}
            className="z-[1000] bg-white border rounded-md p-3 w-[350px] shadow-lg"
          >
            <p className="font-semibold">{isLocked ? 'LOCKED:' : 'UNLOCKED:'}</p>
            <span>
              {isLocked
                ? 'On rosters created from this template, this shift will not be assignable to any other staff member.'
                : 'This staff member will be assigned by default, but can be changed after a roster is created.'}
            </span>
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};
